export default __webpack_public_path__ + "static/media/dsstest1.ff5d669d.jpg";